export type AccessActor = 'founder' | 'invited-client';

export type AccessErrorCode =
  | 'IDENTITY_UNAVAILABLE'
  | 'IDENTITY_REJECTED'
  | 'INVITATION_INVALID'
  | 'INVITATION_EXPIRED'
  | 'NETWORK_ERROR'
  | 'UNEXPECTED_RESPONSE';

export interface AccessError {
  readonly code: AccessErrorCode;
  readonly message: string;
}

export interface AuthenticatedIdentity {
  readonly actor: AccessActor;
  readonly displayName: string;
  readonly redirectTo: '/dashboard';
}

export type AccessResult =
  | { readonly ok: true; readonly identity: AuthenticatedIdentity }
  | {
      readonly ok: false;
      readonly error: AccessError;
      readonly pending?: false;
    }
  | {
      readonly ok: false;
      readonly error: AccessError;
      readonly pending: true;
    };

export interface InvitationCredentials {
  readonly email: string;
  readonly token: string;
}

export function normalizeInvitationCredentials(
  credentials: InvitationCredentials,
): InvitationCredentials {
  return {
    email: credentials.email.trim().toLowerCase(),
    token: credentials.token.trim(),
  };
}

export function validateInvitationCredentials(
  credentials: InvitationCredentials,
): AccessError | null {
  const normalized = normalizeInvitationCredentials(credentials);
  const basicEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;

  if (!basicEmailPattern.test(normalized.email)) {
    return {
      code: 'INVITATION_INVALID',
      message: 'Escribe el correo asociado a tu invitación.',
    };
  }

  if (normalized.token.length < 24 || normalized.token.length > 256) {
    return {
      code: 'INVITATION_INVALID',
      message: 'El enlace o código de invitación no es válido.',
    };
  }

  return null;
}
